export default "__VITE_ASSET__vFgp7w4S__"